/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_DurationInputs */



/**
* | output |
* | --- |
* | "Media Duration" |
*
* @param {Media_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_duration = /** @type {((inputs?: Media_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Durée média")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mediendauer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durata del supporto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Продолжительность медиаконтента")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duración de los medios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("媒体时长")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアの長さ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया अवधि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duração da mídia")
	return /** @type {LocalizedString} */ ("Media Duration")
});